module.exports = __webpack_public_path__ + "static/media/about-us-history-2.55face46.webp";